import React from 'react';
import './RankingDisclaimer.css';

/**
 * SternTournamentDisclaimer component explains the Stern tournament scoring system
 */
function SternTournamentDisclaimer() {
  return (
    <div className="ranking-disclaimer">
      <p>
        In this tournament, lower points are better. Rankings are calculated across all machines in this event by adding up your ranks.
        You are penalized 1000 points for not playing a game, so it's generally recommended to play all games. This assumes that the top 4 players will move on to a finals round.
      </p>
    </div>
  );
}

export default SternTournamentDisclaimer;